const areas = {
  SE: "Secretaría Ejecutiva (SE)",
  ATCSyP: "Área Técnica de Comunicación Social y Prensa (ATCSyP)",
  ATI: "Área Técnica de Informática (ATI)",
  ATTAI: "Área Técnica de Transparencia y Acceso a la Información (ATTAI)",
  OIC: "Órgano Interno de Control (OIC)",
  DAJ: "Dirección de Asuntos Jurídicos (DAJ)",
  DOCEyEC: "Dirección de Organización, Capacitación Electoral y Educación Cívica (DOCEyEC)",
  DPAyF: "Dirección de Prerrogativas, Administración y Fiscalización (DPAyF)",
  ATCC: "Área Técnica de Consulta Ciudadana (ATCC)",
  UTCE: "Unidad Técnica de lo Contencioso Electoral (UTCE)",
  CGyND: "Comisión de Género y No Discriminación (CGyND)",
  CAMRC: "Consejeria Anakaren Monserrat Rojas Cuautle",
  CBFBR: "Consejeria Brenda Fernanda Barrón Rugerio",
  CYMP: "Consejeria Yedith Martínez Pinillo",
  CJCA: "Consejeria Janet Cervantes Ahuatzi",
  CHNC: "Consejeria Hermenegildo Neria Carreño",
  PEAG: "Presidencia Emmanuel Ávila González"
};

export const dataPOA = {
  2018: [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATI" },
    { id: 4, area: "ATTAI" },
    { id: 5, area: "OIC" },
    { id: 6, area: "DAJ" },
    { id: 7, area: "DOCEyEC" },
    { id: 8, area: "DPAyF" },
  ],
  2019: [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATCC" },
    { id: 4, area: "ATI" },
    { id: 5, area: "ATTAI" },
    { id: 6, area: "DAJ" },
    { id: 7, area: "DOCEyEC" },
    { id: 8, area: "DPAyF" },
  ],
  2020: [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATCC" },
    { id: 4, area: "ATI" },
    { id: 5, area: "ATTAI" },
    { id: 6, area: "DAJ" },
    { id: 7, area: "DOCEyEC" },
    { id: 8, area: "DPAyF" },
  ],
  2023: [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATI" },
    { id: 4, area: "ATTAI" },
    { id: 5, area: "DAJ" },
    { id: 6, area: "DPAyF" },
  ],
  2024: [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATI" },
    { id: 4, area: "ATTAI" },
    { id: 5, area: "OIC" },
    { id: 6, area: "DAJ" },
    { id: 7, area: "DOCEyEC" },
    { id: 8, area: "DPAyF" },
    { id: 9, area: "ATCC" },
    { id: 10, area: "UTCE" },
  ],
  2025: [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATI" },
    { id: 4, area: "ATTAI" },
    { id: 5, area: "OIC" },
    { id: 6, area: "DAJ" },
    { id: 7, area: "DOCEyEC" },
    { id: 8, area: "DPAyF" },
    { id: 9, area: "ATCC" },
    { id: 10, area: "UTCE" },
    { id: 11, area: "CGyND" },
    { id: 12, area: "CAMRC" },
    { id: 13, area: "CBFBR" },
    { id: 14, area: "CYMP" },
    { id: 15, area: "CJCA" },
    { id: 16, area: "CHNC" },
    { id: 17, area: "PEAG" },
  ],
  "2026_T1": [
    { id: 1, area: "SE" },
    { id: 2, area: "ATCSyP" },
    { id: 3, area: "ATI" },
    { id: 4, area: "ATTAI" },
    { id: 5, area: "OIC" },
    { id: 6, area: "DAJ" },
    { id: 7, area: "DOCEyEC" },
    { id: 8, area: "DPAyF" },
    { id: 9, area: "ATCC" },
    { id: 10, area: "UTCE" },
    { id: 11, area: "CGyND" },
    { id: 12, area: "CAMRC" },
    { id: 13, area: "CBFBR" },
    { id: 14, area: "CYMP" },
    { id: 15, area: "CJCA" },
    { id: 16, area: "CHNC" },
    { id: 17, area: "PEAG" },
  ],
};

export const getPOAData = (key) => {
  const registros = dataPOA[key];
  if (!registros) return [];

  return registros.map((poa) => ({
    id: poa.id,
    title: `${areas[poa.area]} ${String(key).replace("_", " - ")}`,
  }));
};
